import { getSpecializationTitle as getSharedSpecializationTitle } from "@tg-jobs/shared/specializations";

export interface SpecializationItem {
  name: string;
  displayName: string;
  titleRu: string;
  titleEn: string;
}

export interface SpecializationDirection {
  id: string;
  titleRu: string;
  shortTitleRu?: string;
  titleEn: string;
  specializations: SpecializationItem[];
}

export const SPECIALIZATION_DIRECTIONS: SpecializationDirection[] = [
  {
    id: "development",
    titleRu: "Разработка",
    titleEn: "Software Development",
    specializations: [
      { name: "backend", displayName: "Backend", titleRu: "Бэкенд разработчик", titleEn: "Backend Developer" },
      { name: "frontend", displayName: "Frontend", titleRu: "Фронтенд разработчик", titleEn: "Frontend Developer" },
      { name: "fullstack", displayName: "Fullstack", titleRu: "Фулстек разработчик", titleEn: "Fullstack Developer" },
      { name: "android", displayName: "Android", titleRu: "Android разработчик", titleEn: "Android Developer" },
      { name: "ios", displayName: "iOS", titleRu: "iOS разработчик", titleEn: "iOS Developer" },
      { name: "one-c", displayName: "1C", titleRu: "1С разработчик", titleEn: "1C Developer" },
    ],
  },
  {
    id: "testing",
    titleRu: "Тестирование",
    titleEn: "Quality Assurance",
    specializations: [
      { name: "qa", displayName: "QA", titleRu: "Инженер по тестированию", titleEn: "QA Engineer" },
    ],
  },
  {
    id: "data-ai",
    titleRu: "Данные и AI",
    titleEn: "Data & AI",
    specializations: [
      { name: "data-scientist", displayName: "Data Scientist", titleRu: "Data Scientist", titleEn: "Data Scientist" },
      { name: "ml-engineer", displayName: "ML Engineer", titleRu: "ML-инженер", titleEn: "Machine Learning Engineer" },
      { name: "data-engineer", displayName: "Data Engineer", titleRu: "Дата-инженер", titleEn: "Data Engineer" },
      { name: "ai-engineer", displayName: "AI Engineer", titleRu: "AI-инженер", titleEn: "AI Engineer" },
    ],
  },
  {
    id: "analytics",
    titleRu: "Аналитика",
    titleEn: "Analytics",
    specializations: [
      { name: "system-analyst", displayName: "System Analyst", titleRu: "Системный аналитик", titleEn: "System Analyst" },
      { name: "business-analyst", displayName: "Business Analyst", titleRu: "Бизнес-аналитик", titleEn: "Business Analyst" },
      { name: "data-analyst", displayName: "Data Analyst", titleRu: "Дата-аналитик", titleEn: "Data Analyst" },
    ],
  },
  {
    id: "design",
    titleRu: "Дизайн",
    titleEn: "Design",
    specializations: [
      { name: "product-designer", displayName: "Product Designer", titleRu: "Продуктовый дизайнер", titleEn: "Product Designer" },
      { name: "ux-ui-designer", displayName: "UX/UI Designer", titleRu: "UX/UI дизайнер", titleEn: "UX/UI Designer" },
      { name: "graphic-designer", displayName: "Graphic Designer", titleRu: "Графический дизайнер", titleEn: "Graphic Designer" },
      { name: "web-designer", displayName: "Web Designer", titleRu: "Веб-дизайнер", titleEn: "Web Designer" },
      { name: "motion-designer", displayName: "Motion Designer", titleRu: "Моушн-дизайнер", titleEn: "Motion Designer" },
      { name: "three-d-artist", displayName: "3D Artist", titleRu: "3D-художник", titleEn: "3D Artist" },
    ],
  },
  {
    id: "management",
    titleRu: "Менеджмент",
    titleEn: "Management",
    specializations: [
      { name: "project-manager", displayName: "Project Manager", titleRu: "Проджект-менеджер", titleEn: "Project Manager" },
      { name: "product-manager", displayName: "Product Manager", titleRu: "Продакт-менеджер", titleEn: "Product Manager" },
      { name: "delivery-manager", displayName: "Delivery Manager", titleRu: "Деливери-менеджер", titleEn: "Delivery Manager" },
    ],
  },
  {
    id: "administration",
    titleRu: "Администрирование",
    titleEn: "Administration & DevOps",
    specializations: [
      { name: "devops-sre", displayName: "DevOps / SRE", titleRu: "DevOps / SRE инженер", titleEn: "DevOps / SRE Engineer" },
      { name: "system-administrator", displayName: "System Administrator", titleRu: "Системный администратор", titleEn: "System Administrator" },
    ],
  },
  {
    id: "infosec",
    titleRu: "Информационная безопасность",
    shortTitleRu: "Инф. безопасность",
    titleEn: "Information Security",
    specializations: [
      { name: "infosec-specialist", displayName: "InfoSec Specialist", titleRu: "Специалист по ИБ", titleEn: "InfoSec Specialist" },
      { name: "pentester", displayName: "Pentester", titleRu: "Пентестер", titleEn: "Pentester" },
    ],
  },
  {
    id: "marketing",
    titleRu: "Маркетинг",
    titleEn: "Marketing",
    specializations: [
      { name: "marketer", displayName: "Marketer", titleRu: "Маркетолог", titleEn: "Marketer" },
      { name: "seo-specialist", displayName: "SEO Specialist", titleRu: "SEO-специалист", titleEn: "SEO Specialist" },
      { name: "smm-specialist", displayName: "SMM Specialist", titleRu: "SMM-специалист", titleEn: "SMM Specialist" },
      { name: "targetologist", displayName: "Targetologist", titleRu: "Таргетолог", titleEn: "Targetologist" },
      { name: "pr-specialist", displayName: "PR Specialist", titleRu: "PR-специалист", titleEn: "PR Specialist" },
    ],
  },
  {
    id: "content",
    titleRu: "Контент",
    titleEn: "Content",
    specializations: [
      { name: "technical-writer", displayName: "Technical Writer", titleRu: "Технический писатель", titleEn: "Technical Writer" },
      { name: "copywriter", displayName: "Copywriter", titleRu: "Копирайтер", titleEn: "Copywriter" },
      { name: "content-manager", displayName: "Content Manager", titleRu: "Контент-менеджер", titleEn: "Content Manager" },
      { name: "ugc-creator", displayName: "UGC Creator", titleRu: "UGC-креатор", titleEn: "UGC Creator" },
    ],
  },
  {
    id: "hr",
    titleRu: "HR",
    titleEn: "Human Resources",
    specializations: [
      { name: "hr-manager", displayName: "HR Manager", titleRu: "HR-менеджер", titleEn: "HR Manager" },
      { name: "recruiter", displayName: "Recruiter", titleRu: "Рекрутер", titleEn: "Recruiter" },
    ],
  },
];

export const SPECIALIZATIONS: SpecializationItem[] = SPECIALIZATION_DIRECTIONS.flatMap(
  (dir) => dir.specializations,
);

export function findSpecialization(nameOrDisplay: string): SpecializationItem | undefined {
  const norm = nameOrDisplay.toLowerCase().trim();
  return SPECIALIZATIONS.find(
    (s) =>
      s.name.toLowerCase() === norm ||
      s.displayName.toLowerCase() === norm ||
      s.titleRu.toLowerCase() === norm ||
      s.titleEn.toLowerCase() === norm,
  );
}

export function getSpecializationTitle(nameOrDisplay: string): string {
  return getSharedSpecializationTitle(findSpecialization(nameOrDisplay)?.name ?? nameOrDisplay);
}

export function findDirectionForSpecialization(nameOrDisplay: string): SpecializationDirection | undefined {
  const norm = nameOrDisplay.toLowerCase().trim();
  return SPECIALIZATION_DIRECTIONS.find((dir) =>
    dir.specializations.some(
      (s) =>
        s.name.toLowerCase() === norm ||
        s.displayName.toLowerCase() === norm ||
        s.titleRu.toLowerCase() === norm ||
        s.titleEn.toLowerCase() === norm,
    ),
  );
}

export const SENIORITY_OPTIONS = [
  { value: "intern", label: "Intern" },
  { value: "junior", label: "Junior" },
  { value: "middle", label: "Middle" },
  { value: "senior", label: "Senior" },
  { value: "lead", label: "Lead / Head" },
];

export const LANGUAGE_OPTIONS = [
  { value: "any", label: "Любой" },
  { value: "ru", label: "Русский" },
  { value: "en", label: "English" },
];
